import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import FileUpload from "@/components/dash/FileUpload";

const selectCls = "h-9 w-full rounded-md border border-input bg-white px-3 text-sm focus:outline-none focus:ring-1 focus:ring-amber-500";

function MultiSelect({ value, options, onChange, tid }) {
  const toggle = (v) => onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  return (
    <div className="max-h-48 overflow-y-auto rounded-md border border-input p-2 space-y-1 bg-white" data-testid={tid}>
      {options.length === 0 && <p className="text-xs text-slate-400 p-1">Belum ada data</p>}
      {options.map((o) => (
        <label key={o.value} className="flex items-start gap-2 text-sm px-1 py-1 rounded hover:bg-slate-50 cursor-pointer">
          <input type="checkbox" className="mt-0.5 accent-amber-500" checked={value.includes(o.value)} onChange={() => toggle(o.value)} />
          <span className="line-clamp-2">{o.label}</span>
        </label>
      ))}
    </div>
  );
}

export default function FieldInput({ field, form, onChange, options }) {
  const tid = `field-${field.name.replace(/_/g, "-")}`;
  const value = form[field.name];
  const set = (v) => onChange({ [field.name]: v });
  switch (field.type) {
    case "textarea":
    case "list":
      return <Textarea rows={field.type === "list" ? 4 : 3} value={value} onChange={(e) => set(e.target.value)} required={field.required} placeholder={field.placeholder} data-testid={tid} />;
    case "select":
      return (
        <select className={selectCls} value={value} onChange={(e) => set(e.target.value)} required={field.required} data-testid={tid}>
          {(field.allowEmpty || !value) && <option value="">{field.emptyLabel || "— Pilih —"}</option>}
          {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      );
    case "multiselect":
      return <MultiSelect value={value || []} options={options} onChange={set} tid={tid} />;
    case "checkbox":
      return (
        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <input type="checkbox" className="h-4 w-4 accent-amber-500" checked={!!value} onChange={(e) => set(e.target.checked)} data-testid={tid} />
          {field.label}
        </label>
      );
    case "datetime":
      return <Input type="datetime-local" value={value} onChange={(e) => set(e.target.value)} required={field.required} data-testid={tid} />;
    case "file":
      return <FileUpload fileName={form.file_name} onUploaded={(r) => onChange({ file_id: r.file_id, file_name: r.file_name })} testid={tid} />;
    default:
      return <Input type={field.type || "text"} value={value} onChange={(e) => set(e.target.value)} required={field.required} placeholder={field.placeholder} data-testid={tid} />;
  }
}
